import styled from 'styled-components';
import { motion } from 'framer-motion';
import { min } from '../../../theme/breakpoints';

export const SectionContainer = styled(motion.div)`
  position: relative;
  background-color: ${({ theme }) => (theme.name === 'uplay' ? theme.colors.Black : theme.colors.Gallery)};

  .shape-latest-updates,
  .pattern-latest-updates {
    background-size: auto 100%;
    background-repeat: no-repeat;
    background-position: 100% 50%;
    width: 100%;

    @media screen and ${min('tablet')} {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 50%;
      z-index: 1;
    }
  }
  .pattern-latest-updates {
    background-repeat: repeat;
    background-size: auto auto;
  }
  .mobile-image {
    display: block;
    position: relative;
    z-index: 2;
    margin: auto;

    @media screen and ${min('tablet')} {
      display: none;
    }
  }
`;

export const BackgroundContainer = styled.div`
  position: relative;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.Froly};

  @media screen and ${min('tablet')} {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 50%;
  }
  .bg-latest-updates,
  .pattern-latest-updates {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .bg-latest-updates {
    background-repeat: no-repeat;
    background-position: 100% 50%;
    z-index: 2;
  }
  .pattern-latest-updates {
    background-size: auto 35%;
    z-index: 1;
  }
`;

export const Shape = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 50%;
  z-index: 2;
  box-shadow: 3px 3px 25px rgba(0, 0, 0, 0.5);
  background-color: rgba(247, 126, 105, 0.7);
  transform: skewX(20deg) translateX(-75%);

  @media screen and ${min('largeTablet')} {
    transform: skewX(45deg) translateX(-50%);
  }
`;

export const ImageContainer = styled(motion.div)`
  display: none;

  @media screen and ${min('tablet')} {
    display: block;
  }
  img {
    display: block;
    max-height: 430px;
  }
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  position: relative;
  z-index: 3;
  padding: 2rem 0 3rem;

  @media screen and ${min('tablet')} {
    flex-direction: row;
    padding: 0;
  }
`;

export const Details = styled.div`
  padding: 2rem 1rem;
  flex: 0 0 50%;

  h2 {
    font-size: 1.75rem;

    @media screen and ${min('tablet')} {
      text-align: left;
    }
    @media screen and ${min('largeTablet')} {
      font-size: 2.8125rem;
    }
  }
`;

export const Description = styled.p`
  text-align: center;
  font-size: 1.125rem;
  margin: 1rem 0;

  @media screen and ${min('tablet')} {
    text-align: left;
  }
  @media screen and ${min('largeTablet')} {
    font-size: 1.5rem;
  }
`;
